
export const generateOfflineTicketNumber = (startingNumber, endingNumber) => {
  const EXCLUDED_TICKETS = [7900000, 7901900, 7904500, 7904501, 7904502, 7904503, 7905800, 7907700, 7909000, 7909300, 7911301, 7912701, 7916700, 7916701, 7916702, 7916703, 7916704, 7916705, 7916706, 7916707, 7916708, 7916709, 7919000, 7921200, 7921201, 7923100, 7927000, 7928700, 7928701, 7928702, 7929900, 7932900, 7932901, 7985600]
  let result = null;
  let currentNum = startingNumber
  
  if(!startingNumber || !endingNumber) {
    return null;
  }
  
  do {
    if(EXCLUDED_TICKETS.includes(currentNum)) {
      currentNum++;
    }else{
      result = currentNum
    }
  }
  while (!result && currentNum <= endingNumber);
  return result;
}